import { useEffect } from 'react';
import { useVideoEditor } from './context/VideoEditorContext';
import { IVideoClip } from '@packages/global';

interface VideoEditorSyncProps {
  onSelectedClipChange: (clip: IVideoClip | null) => void;
  onSelectedClipViewChange?: (view: 'video' | 'audio' | 'text' | null) => void;
}

/**
 * 同步组件：将 Context 中的 selectedClip 和 selectedClipView 同步到父组件
 * 这样父组件可以响应 Timeline 等组件的 clip 选择和视图切换
 */
export default function VideoEditorSync({ onSelectedClipChange, onSelectedClipViewChange }: VideoEditorSyncProps) {
  const { state } = useVideoEditor();

  useEffect(() => {
    onSelectedClipChange(state.selectedClip);
  }, [state.selectedClip, onSelectedClipChange]);

  useEffect(() => {
    if (onSelectedClipViewChange) {
      onSelectedClipViewChange(state.selectedClipView);
    }
  }, [state.selectedClipView, onSelectedClipViewChange]);

  return null; // 这是一个纯逻辑组件，不渲染任何内容
}
